function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.3362 42H11.0431C10.5435 42 10.1379 41.6814 10.1379 41.2759C10.1379 40.8704 10.5435 40.5518 11.0431 40.5518H27.3362C27.8359 40.5518 28.2414 40.8704 28.2414 41.2759C28.2414 41.6814 27.8359 42 27.3362 42Z",
  fill: "#F9D937"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.209 38.3794H13.1702C12.6955 38.3794 12.3103 38.0608 12.3103 37.6553C12.3103 37.2498 12.6955 36.9312 13.1702 36.9312H25.209C25.6837 36.9312 26.0689 37.2498 26.0689 37.6553C26.0689 38.0608 25.6837 38.3794 25.209 38.3794Z",
  fill: "#F9D937"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3762 32.5862H21.7269C29.477 24.2655 29.73 5.6 29.6861 1.44828H9.41697C9.37481 5.6 9.63113 24.2655 17.3762 32.5862ZM21.7441 34.7586H16.6357C16.4092 34.7586 16.193 34.6717 16.0329 34.4979C6.46158 24.7308 7.23294 1.80745 7.2704 0.834207C7.28913 0.364965 7.66374 0 8.12179 0H30.258C30.7143 0 31.0907 0.364965 31.1094 0.834207C31.1451 1.80745 31.9182 24.7308 22.3452 34.4979C22.1868 34.6717 21.9705 34.7586 21.7441 34.7586Z",
  fill: "#F9D937"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6112 31.862C18.3382 31.862 18.0689 31.7561 17.8825 31.5443C10.944 23.5837 10.2135 7.645 10.1382 4.5208C10.1269 4.04423 10.5392 3.63826 11.057 3.62061C11.6219 3.65591 12.0098 3.99127 12.0211 4.4855C12.2225 12.8167 14.2617 24.6075 19.3399 30.4146C19.6675 30.8029 19.6091 31.3501 19.2062 31.6678C19.033 31.7914 18.8202 31.862 18.6112 31.862Z",
  fill: "#F9D937"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.162 28.9654C11.9947 28.9654 11.8256 28.9121 11.6775 28.8056C11.3359 28.5749 3.32477 23.0185 0.898938 16.8763C-0.798448 12.5626 -0.0159774 7.43232 2.60504 5.67487C3.41539 5.12456 5.60771 4.16596 8.42216 7.04177C8.76373 7.37906 8.76373 7.94712 8.42216 8.28441C8.08233 8.63945 7.53164 8.63945 7.19007 8.28441C6.2281 7.30805 4.81826 6.31394 3.56352 7.14828C1.84174 8.31991 1.02616 12.4384 2.51616 16.2018C4.74158 21.8469 12.5715 27.2967 12.6517 27.35C13.0508 27.6163 13.1536 28.1666 12.8852 28.5749C12.7162 28.8234 12.4426 28.9654 12.162 28.9654Z",
  fill: "#F9D937"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.2174 28.9654C25.9368 28.9654 25.6632 28.8234 25.4941 28.5749C25.2257 28.1666 25.3286 27.6163 25.7277 27.35C25.8078 27.2967 33.6382 21.8469 35.8638 16.2018C37.3539 12.4384 36.5383 8.31991 34.8164 7.14828C33.5598 6.31394 32.1534 7.30805 31.1879 8.28441C30.848 8.63945 30.2973 8.63945 29.9557 8.28441C29.6159 7.94712 29.6159 7.37906 29.9557 7.04177C32.7738 4.16596 34.9645 5.12456 35.7749 5.67487C38.3961 7.43232 39.1769 12.5626 37.4811 16.8763C35.0551 23.0185 27.0435 28.5749 26.7019 28.8056C26.5538 28.9121 26.3847 28.9654 26.2174 28.9654Z",
  fill: "#F9D937"
});

var SvgChampion = function SvgChampion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChampion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/champion.32dd4c4a.svg";
export { ForwardRef as ReactComponent };